@if (isShownPlaceholder) {
  <ng-template *ngTemplateOutlet="temlateByName.ssrPlaceholder.template"></ng-template>
} @else {
  <swiper-container init="false">
    <ng-container *ngIf="{ swiperSlidesConfig: swiperSlidesConfig$ | async } as obs">
      @if (items.length > 0 && obs.swiperSlidesConfig) {
        @for (item of items; track $index; let i = $index) {
          @if (item | async; as data) {
            <swiper-slide>
              <ng-container
                *ngTemplateOutlet="
                  template;
                  context: { item: data, classList: getSlideClasses(obs.swiperSlidesConfig, i) }
                "
              ></ng-container>
            </swiper-slide>
          }
        }
      } @else {
        <ng-content></ng-content>
      }
    </ng-container>
  </swiper-container>
}
